import React from 'react';
import BWAccordion from 'components/shared/BWAccordion';
import FormInput from 'components/shared/BWFormControl/FormInput';
import FormItem from 'components/shared/BWFormControl/FormItem';
import FormTextArea from 'components/shared/BWFormControl/FormTextArea';

const RecruitmentInfoEn = ({ disabled, title }) => {

  return (
    <BWAccordion title={title}>
      <div className='bw_row'>
        <div className='bw_col_12'>
          <FormItem label='Tiêu đề tuyển dụng (tiếng anh)' isRequired={false} disabled={disabled}>
            <FormInput
              field='recruitment_name_en'
              placeholder='Nhập tiêu đề tuyển dụng'
            />
          </FormItem>
        </div>
        <div className='bw_col_12'>
          <FormItem disabled={disabled} label='Giới thiệu (tiếng anh)'>
            <FormTextArea type='text' field='introduction_en' placeholder='' />
          </FormItem>
        </div>
      </div>
    </BWAccordion>
  );
};

export default RecruitmentInfoEn;
